import goto from "src/pageDefinitions/goto";
import { trackEvent } from "src/utils/api/tracker";
import { useOnce } from "./lifecycle";
import { useServerContext } from "./redux";
import { useAuth } from "@noom/hive-auth";

export function pathIsInSubscriptionCancelContext(
  path: string = window.location.pathname
) {
  const subscriptionContextRegex =
    /\/(subscription|ps)\/(cancel-trial|cancel-subscription|cancel-membership|hm-cancel-trial|hm-cancel-subscription|med-downgrade)/;
  return subscriptionContextRegex.test(path);
}

export function LegacyCounterOfferContextRedirect() {
  const serverContext = useServerContext();
  const { isAuthenticated } = useAuth();

  useOnce(() => {
    trackEvent("RedirectLegacyCounterOffer", {
      isInTrial: serverContext.is_in_trial,
      isHM: serverContext.subscription_is_hm,
      isAuthenticated,
    });

    goto.cancelSubscription(
      serverContext.subscription_is_hm,
      serverContext.is_in_trial
    );
  });
  return null;
}
